import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { ClientInitialsForAdd, ClientInitialsForUpdate } from './interfaces/AccountClientClass';
import { getClientDatatableAsync, addClientsAsync, updateClientsAsync, resetSelectedRecordObjectInState, setClientActiveTab } from './AccountClientSlice';
import Select, { StylesConfig } from 'react-select';
import fetchAPI from '../../common/fetchAPI';
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../common/Toastr';
import clsx from 'clsx';
import { determineCommaSeprater, formatNumberCustomoriginalapiv2, validateCultureNumber, formatNumberCustomoriginal, parseLocalizedNumber, parseFlexibleNumber, parseLocaleNumber, dropDownSelectionStyles, dateFormatByAccountCulture, getValueFromResource } from '../../common/timeLiveFunction';
import CanvasLoader from '../../common/CanvasLoader';
import DatePicker from "react-datepicker";
import moment from 'moment';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import infoSVG from '../../assets/image/info-SVG.svg';
import { TOOLTIP_STYLE } from '../../common/TooltipStyle';

const AccountClientForm = (props: any) => {
    const { t } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(ClientInitialsForAdd);
    const { selectedRecord, isLoading, tab } = useAppSelector((state) => state.accountClient);
    const dispatch = useAppDispatch();
    const [selectedOptionCountry, setselectedOptionCountry] = useState<{ [object: string]: any }>();
    const [selectedOptionInvoiceTemplate, setselectedOptionInvoiceTemplate] = useState<{ [object: string]: any }>();
    const [countryArray, SetCountryArray] = useState<any | ''>([]);
    const [invoicetemplateArray, SetInvoiceTempateArray] = useState<any | ''>([]);
    const [fixedBidBillingModeArray, SetFixedBidBillingModeArray] = useState<any | ''>([]);
    const [selectedOptionFixedBidBillingMode, setSelectedOptionFixedBidBillingMode] = useState<any | ''>([]);
    const [showDiv, setShowDiv] = useState(false);
    const { decimalPlaces, maxMenuHeight, accessToken, CurrentCultureDateFormat, countryId, cultureInfoName, customFieldInsertionFormat, calendarStartDay } = useAppSelector((state) => state.globalState)
    const [isCanvasLoader, setIsCanvasLoader] = useState(true);
    const [customFieldsArray, SetCustomFieldsArray] = useState<any | ''>([]);
    const formikRef = useRef<any>(null);
    const [showErrorSummary, setShowErrorSummary] = useState(false);
    const [serverError, setServerError] = useState('');
const culture = cultureInfoName; // e.g. "es-ES" or "en-US"


    const getCountryAsync = async () => {
        const response = await fetchAPI("api/ExpensePolicies/GetCountry", "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        json.map((item: any) => {
            item.value = item.CountryId;
            item.label = item.Country;
            delete item.CountryId;
            delete item.Country;
        });
        SetCountryArray(json);
    }

    const getInvoiceTemplateAsync = async () => {
        try {
            const response = await fetchAPI("api/V2/InvoiceTemplate", "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const json = await response.json();
            const data = Array.isArray(json.Data) ? json.Data : [];
            const processedData = data.map((item: any) => ({
                value: item.AccountInvoiceTemplateId,
                label: item.AccountInvoiceTemplateName
            }));
            processedData.unshift({ value: '', label: 'None' });
            SetInvoiceTempateArray(processedData);
            const AccountInvoiceTemplateId = processedData[0].value;
        } catch (error) {
            console.error("Error fetching invoice templates:", error);
        }
    }

    const getFixedBidBillingModeAsync = async () => {
        const FixedBidBillingMode = [
            { label: 'None', value: 0 },
            { label: 'Fixed Bid Client', value: 1 },
            { label: 'Fixed Bid Project', value: 2 },
            { label: 'Fixed Bid Task', value: 3 }
        ];
        SetFixedBidBillingModeArray(FixedBidBillingMode);
    }
    const getFormattedCustomField = (fieldName: string, value: any) => {
        const field = customFieldsArray.find((item: any) => item.DatabaseFieldName === fieldName);
        if (field && field.MasterCustomDataTypeName === 'Number' && value) {
            return value.toString().replace(',', '.');
        }
        return value;
    };

    const setCustomFieldValues = (customField: string, customFieldData: any, customFields: any) => {
        let foundItem = customFields.find((item: any) => item.DatabaseFieldName === customField);
        if (!foundItem) return customFieldData;
        if (foundItem.MasterCustomDataTypeName === 'Date') {
            return customFieldData;
        }
        else if (foundItem.MasterCustomDataTypeName === 'Number') {
            if (customFieldData !== null && customFieldData !== undefined && customFieldData !== '') {
                return formatNumberCustomoriginalapiv2(cultureInfoName.toString(), customFieldData, decimalPlaces);
            }
            return customFieldData;
        }
        else {
            return customFieldData;
        }
    }

    useEffect(() => {
        setIsCanvasLoader(true);
        let stateItem: any = {}
        dispatch(setClientActiveTab('Basic'))
        setServerError('');
        if (Object.keys(selectedRecord).length > 0) {
                       const tempObj: any = selectedRecord;
            Object.keys(ClientInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.CustomField1 = stateItem.CustomField1 ? setCustomFieldValues('CustomField1', stateItem.CustomField1, customFieldsArray)  : '';
            stateItem.CustomField2 = stateItem.CustomField2 ? setCustomFieldValues('CustomField2', stateItem.CustomField2, customFieldsArray) : '';
            stateItem.CustomField3 = stateItem.CustomField3 ? setCustomFieldValues('CustomField3', stateItem.CustomField3, customFieldsArray) : '';
            stateItem.CustomField4 = stateItem.CustomField4 ? setCustomFieldValues('CustomField4', stateItem.CustomField4, customFieldsArray) : '';
            stateItem.CustomField5 = stateItem.CustomField5 ? setCustomFieldValues('CustomField5', stateItem.CustomField5, customFieldsArray) : '';
            stateItem.CustomField6 = stateItem.CustomField6 ? setCustomFieldValues('CustomField6', stateItem.CustomField6, customFieldsArray) : '';
            stateItem.CustomField7 = stateItem.CustomField7 ? setCustomFieldValues('CustomField7', stateItem.CustomField7, customFieldsArray) : '';
            stateItem.CustomField8 = stateItem.CustomField8 ? setCustomFieldValues('CustomField8', stateItem.CustomField8, customFieldsArray) : '';
            stateItem.CustomField9 = stateItem.CustomField9 ? setCustomFieldValues('CustomField9', stateItem.CustomField9, customFieldsArray) : '';
            stateItem.CustomField10 = stateItem.CustomField10 ? setCustomFieldValues('CustomField10', stateItem.CustomField10, customFieldsArray) : '';
            stateItem.CustomField11 = stateItem.CustomField11 ? setCustomFieldValues('CustomField11', stateItem.CustomField11, customFieldsArray) : '';
            stateItem.CustomField12 = stateItem.CustomField12 ? setCustomFieldValues('CustomField12', stateItem.CustomField12, customFieldsArray) : '';
            stateItem.CustomField13 = stateItem.CustomField13 ? setCustomFieldValues('CustomField13', stateItem.CustomField13, customFieldsArray) : '';
            stateItem.CustomField14 = stateItem.CustomField14 ? setCustomFieldValues('CustomField14', stateItem.CustomField14, customFieldsArray) : '';
            stateItem.CustomField15 = stateItem.CustomField15 ? setCustomFieldValues('CustomField15', stateItem.CustomField15, customFieldsArray) : '';
            setCurrentFieldsData(stateItem);
            setselectedOptionCountry(countryArray.find((option: any) => option.value == tempObj.CountryId));         
            if (tempObj.FixedBidBillingMode === "Fixed Bid Client") {
                setSelectedOptionFixedBidBillingMode(fixedBidBillingModeArray.find((option: any) => option.value == 1));
                setShowDiv(true);
            }
            else if (tempObj.FixedBidBillingMode === "Fixed Bid Project") {
                setSelectedOptionFixedBidBillingMode(fixedBidBillingModeArray.find((option: any) => option.value == 2));
                setShowDiv(false);
            }
            else if (tempObj.FixedBidBillingMode === "Fixed Bid Task") {
                setSelectedOptionFixedBidBillingMode(fixedBidBillingModeArray.find((option: any) => option.value == 3));
                setShowDiv(false);
            }
            else if (tempObj.FixedBidBillingMode === "None" || tempObj.FixedBidBillingMode === null) {
                setSelectedOptionFixedBidBillingMode(fixedBidBillingModeArray.find((option: any) => option.value == 0));
                setShowDiv(false);
            }
          
           if (tempObj.AccountInvoiceTemplateId !== "None" && tempObj.AccountInvoiceTemplateId !== null) {
                setselectedOptionInvoiceTemplate(invoicetemplateArray.find((option: any) => option.value == tempObj.AccountInvoiceTemplateId));
            } else {
                setselectedOptionInvoiceTemplate(invoicetemplateArray.find((option: any) => option.value == 0));
            }
            stateItem.IsDisabled = stateItem.IsDisabled === "Yes" ? true : false;
        }
        else {
            setSelectedOptionFixedBidBillingMode(fixedBidBillingModeArray.find((option: any) => option.value == 0));
            setselectedOptionInvoiceTemplate(invoicetemplateArray.find((option: any) => option.value == 0));
            setselectedOptionCountry(countryArray.find((option: any) => option.value == countryId));
            customFieldsArray.forEach((field: any) => {
                const { DatabaseFieldName, DefaultValue, MasterCustomDataTypeName } = field;
                if (DatabaseFieldName in currentFieldsData) {
                    if (MasterCustomDataTypeName == 'Date') {
                        // currentFieldsData[DatabaseFieldName] = moment().format(CurrentCultureDateFormat.toUpperCase());
                        currentFieldsData[DatabaseFieldName] = moment(new Date()).format(customFieldInsertionFormat);
                    }
                    else {
                        currentFieldsData[DatabaseFieldName] = DefaultValue ? DefaultValue : '';
                    }
                }
            });
            setCurrentFieldsData(ClientInitialsForAdd);
            setIsCanvasLoader(false);
            setShowDiv(false);
             setServerError('');
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
        if (formikRef.current) {
            formikRef.current.resetForm();
        }
        // dispatch(setClientActiveTab('Basic'))
        setIsCanvasLoader(false);
    }, [selectedRecord, fixedBidBillingModeArray.length, invoicetemplateArray.length])

    useEffect(() => {
        getInvoiceTemplateAsync();
        getCountryAsync();
        getFixedBidBillingModeAsync();
        getCustomFieldTemplateByMasterEntityTypeIdAsync();

    }, [])

    const getCustomFieldTemplateByMasterEntityTypeIdAsync = async () => {
        let MasterEntityTypeId: string = 'E448AED9-EAB5-4CF7-A171-2A86BE2BBA9E';
        const response = await fetchAPI('api/v2/CustomFields/CustomFieldTemplateByMasterEntityType/' + MasterEntityTypeId, 'GET', '', true, accessToken);
        const json = await response.json();
        if (json.length > 0) {
            SetCustomFieldsArray(json);
        }
        else {
            SetCustomFieldsArray([]);
        }
    }

    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const handleSubmit = (values: any) => {
        const normalizedValues = { ...values,
        CustomField1: getFormattedCustomField('CustomField1', values.CustomField1),
        CustomField2: getFormattedCustomField('CustomField2', values.CustomField2),
        CustomField3: getFormattedCustomField('CustomField3', values.CustomField3),
        CustomField4: getFormattedCustomField('CustomField4', values.CustomField4),
        CustomField5: getFormattedCustomField('CustomField5', values.CustomField5),
        CustomField6: getFormattedCustomField('CustomField6', values.CustomField6),
        CustomField7: getFormattedCustomField('CustomField7', values.CustomField7),
        CustomField8: getFormattedCustomField('CustomField8', values.CustomField8),
        CustomField9: getFormattedCustomField('CustomField9', values.CustomField9),
        CustomField10: getFormattedCustomField('CustomField10', values.CustomField10),
        CustomField11: getFormattedCustomField('CustomField11', values.CustomField11),
        CustomField12: getFormattedCustomField('CustomField12', values.CustomField12),
        CustomField13: getFormattedCustomField('CustomField13', values.CustomField13),
        CustomField14: getFormattedCustomField('CustomField14', values.CustomField14),
        CustomField15: getFormattedCustomField('CustomField15', values.CustomField15) };
        const numericFields = ['DefaultBillingRate', 'FixedCost'];

  numericFields.forEach(field => {
    if (normalizedValues[field] !== undefined && normalizedValues[field] !== null) {
      const parsedValue = parseLocalizedNumber(normalizedValues[field]);
      normalizedValues[field] = parsedValue;
    }
  });
        if (Object.keys(selectedRecord).length > 0) {


            dispatch(updateClientsAsync(normalizedValues))
                .unwrap()
                .then((originalPromiseResult) => {
                    if (originalPromiseResult.StatusCode === "200") {
                        ShowToast("Clients Updated Successfully", 'Success', "success", "toast-top-right");
                        const storedObject = localStorage.getItem('objClient');
                        let clientData = storedObject ? JSON.parse(storedObject) : {};
                        clientData.AccountClientName = values.ClientName ? values.ClientName : values.PartyName;
                        localStorage.setItem('objClient', JSON.stringify(clientData));
                        if (closeButtonRef.current) {
                            closeButtonRef.current.click();
                        }
                    } else {
                        setServerError(originalPromiseResult.ResponseMessage);
                    }
                    
                })
                
                .catch((rejectedValueOrSerializedError) => {
                     
                })
        }
        else {
            if (selectedOptionFixedBidBillingMode.label === "None") {
                delete normalizedValues.FixedBidBillingMode;
            }
            else {
                normalizedValues.FixedBidBillingMode = selectedOptionFixedBidBillingMode.label;
            }
            dispatch(addClientsAsync(normalizedValues))
                .unwrap()
                .then((originalPromiseResult) => {
                    //ShowToast("Client Inserted Successfully", 'Success', "success", "toast-top-right");
                    

                    if (originalPromiseResult.StatusCode === "201") {
                        setServerError('');
                        ShowToast("Client Inserted Successfully", 'Success', "success", "toast-top-right")
                        if (closeButtonRef.current) {
                            closeButtonRef.current.click();
                        }
                    }
                    else {
                        setServerError(originalPromiseResult.ResponseMessage);
                       // ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                    }
                                  
                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
       
        setShowDiv(false);
    }

    const handleCloseOnClickEvent = () => {
        setShowDiv(false)
        dispatch(setClientActiveTab('Basic'))
        dispatch(resetSelectedRecordObjectInState());
    }

    const handleChangeCountry = (data: any, Name: string, values: any) => {
        const { value, label } = data;
        setselectedOptionCountry({ value: value, label: label });
        setCurrentFieldsData({ ...values, 'CountryId': value });
    }

    const handleChangeInvoiceTemplate = (data: any, Name: string, values: any) => {
        const { value, label } = data;
        setselectedOptionInvoiceTemplate({ value: value, label: label });
        setCurrentFieldsData({ ...values, 'AccountInvoiceTemplateId': value });
    }

    const handleChangeDropdown = (data: any, Name: string, values: any) => {
        const { value, label } = data;
        if (Name === 'FixedBidBillingMode') {
            setSelectedOptionFixedBidBillingMode({ value: value, label: label });
            setCurrentFieldsData({ ...values, 'FixedBidBillingMode': value });
        }
        if (label == 'Fixed Bid Client') {
            setShowDiv(true);
        } else {
            setShowDiv(false);
        }
    }

    const validationSchema = yup.object().shape({
      ClientName: yup
    .string()
    .trim()
    .required(getValueFromResource('Client Name is required', dispatch, t))
    .max(400, getValueFromResource('Client Name must not exceed 400 Characters', dispatch, t)),
ClientCode: yup
    .string()
    .trim()
    .max(100, getValueFromResource('Client Nick must not exceed 100 Characters', dispatch, t)),
Notes: yup
    .string()
    .trim()
    .max(1000, getValueFromResource('Notes must not exceed 1000 characters', dispatch, t)),
EMailAddress: yup
    .string()
    .trim()
    .email(getValueFromResource('Invalid email address', dispatch, t)),
        ...Object.fromEntries(
            customFieldsArray
                .filter((x: any) => !x.IsDisabled)
                .map((x: any) => {
                    let yupSchema;
                    if (x.MasterCustomDataTypeName === 'Number') {
                                    yupSchema = yup
                                        .string()
                                        .test(
                                            'culture-format-check',
                                            () => {
                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                return isComma
                                                    ? `${x.CustomFieldCaption} allows only numbers and comma (,)`
                                                    : `${x.CustomFieldCaption} allows only numbers and dot (.)`;
                                            },
                                            (value) => {
                                                if (!value) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());

                                                return isComma
                                                    ? /^\d+(,\d+)?$/.test(value)
                                                    : /^\d+(\.\d+)?$/.test(value);
                                            }
                                        )

                                        // Minimum value check
                                        .test(
                                            'min-value',
                                            `${x.CustomFieldCaption} must be at least ${x.MinimumValue}`,
                                            (value) => {
                                                if (!value || x.MinimumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue >= x.MinimumValue;
                                            }
                                        )

                                        // Maximum value check
                                        .test(
                                            'max-value',
                                            `${x.CustomFieldCaption} must be at most ${x.MaximumValue}`,
                                            (value) => {
                                                if (!value || x.MaximumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue <= x.MaximumValue;
                                            }
                                        );
                    }
                    else if (x.MasterCustomDataTypeName === 'Text') {
                        // Assuming it's a text field
                        yupSchema = yup.string().trim();

                        if (x.MaximumLength != null) {
                            yupSchema = yupSchema.max(x.MaximumLength, `${x.CustomFieldCaption} must be at most ${x.MaximumLength} characters`);
                        }
                    }
                    else if (x.MasterCustomDataTypeName === 'Date') {
                        yupSchema = yup.date()
                            .nullable()
                            .typeError(`Please enter a valid ${x.CustomFieldCaption}`)
                            .min(new Date('1900-01-01'), `${x.CustomFieldCaption} must be after 01/01/1900`)
                        // .max(new Date(), `${x.CustomFieldCaption} must be on or before today`);
                    }
                    if (x.IsRequired) {
                        yupSchema = yupSchema?.required(`${x.CustomFieldCaption} is required`);
                    }
                    // if(x.MasterCustomDataTypeName === 'Number' || x.MasterCustomDataTypeName === 'Text' || x.MasterCustomDataTypeName === 'Drop-Down')
                    // {
                    //     if (x.IsRequired && x.DefaultValue ==='') {
                    //         yupSchema = yupSchema?.required(`${x.CustomFieldCaption} is required`);
                    //     }
                    // }
                    // else
                    // {
                    //     if (x.IsRequired) {
                    //         yupSchema = yupSchema?.required(`${x.CustomFieldCaption} is required`);
                    //     }
                    // }
                    return [x.DatabaseFieldName, yupSchema];
                })
        ),
    });
    const handleBlurValidateAll = (setFieldTouched: any, values: any, validateForm: any) => {
        // Mark all fields as touched
        Object.keys(values).forEach(field => {
            setFieldTouched(field, true);
        });
        // Validate all fields
        validateForm();
    };

    return (
        <>
            <Formik
                innerRef={formikRef}
                initialValues={{
                    ...currentFieldsData,
                    CountryId: selectedOptionCountry?.value, FixedBidBillingMode: selectedOptionFixedBidBillingMode?.value,
                    DefaultBillingRate: currentFieldsData.DefaultBillingRate,
                    //DefaultBillingRate: currentFieldsData.DefaultBillingRate || formatNumberCustomoriginalapiv2(cultureInfoName.toString(), 0, decimalPlaces),
                    FixedCost: currentFieldsData.FixedCost || formatNumberCustomoriginalapiv2(cultureInfoName.toString(), 0, decimalPlaces)
                }}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values);  }}
                validationSchema={validationSchema}                
            // validateOnChange={false}
            >
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit, setFieldValue, validateForm }) => (
                    <Fragment>

                        <div className='card-body py-3' style={{ overflowY: 'auto' }}>
                            {isCanvasLoader ? <CanvasLoader /> : <>
                                <div className='row'>
                                    <div className="col-md-12 mb-6">
                                        <label className=" required form-label">
                                            {/* {t('Client Name')} */}
                                            {getValueFromResource('Client Name',dispatch, t)}
                                            </label>
                                        <input type="text" className="form-control fs-7 fw-normal" id='ClientName' value={values.ClientName} name='ClientName'
                                            onChange={handleChange('ClientName')}
                                            ref={defaultFocusRef}
                                            placeholder=
                                            // {t('Client Name')}
                                            {getValueFromResource('Client Name',dispatch, t)}
                                        //onBlur={() => setFieldTouched('ClientName')}
                                        // onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                        />
                                        <div style={{ paddingRight: 20 }}>
                                            {touched.ClientName && errors.ClientName &&
                                                <p className='errorMsg'>{errors.ClientName as string}</p>
                                            }
                                            {serverError && (
                                                <p className='errorMsg'>{serverError}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className='card-header' style={{ marginLeft: '-30px' }}>
                                    <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap' role='tablist' style={{ marginTop: 8 }}>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer tabFontWeight tabFontWeight`, { active: tab === 'Basic' })}
                                                onClick={() => dispatch(setClientActiveTab('Basic'))}
                                                role='tab'
                                            >
                                                {/* {t('Basic')} */}
                                                {getValueFromResource('Basic',dispatch, t)}
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Details' })}
                                                onClick={() => dispatch(setClientActiveTab('Details'))}
                                                role='tab'
                                            >
                                                {/* {t('Details')} */}
                                                {getValueFromResource('Details',dispatch, t)}
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Notes' })}
                                                onClick={() => dispatch(setClientActiveTab('Notes'))}
                                                role='tab'
                                            >
                                                {/* {t('Notes')} */}
                                                {getValueFromResource('Notes',dispatch, t)}
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Billing' })}
                                                onClick={() => dispatch(setClientActiveTab('Billing'))}
                                                role='tab'
                                            >
                                                {/* {t('Billing')} */}
                                                {getValueFromResource('Billing',dispatch, t)}
                                            </a>
                                        </li>
                                        {customFieldsArray && customFieldsArray.length > 0 &&
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'CustomField' })}
                                                    onClick={() => dispatch(setClientActiveTab('CustomField'))}
                                                    role='tab'
                                                >
                                                    {/* {t('Custom Field')} */}
                                                    {getValueFromResource('Custom Field',dispatch, t)}
                                                </a>
                                            </li>
                                        }
                                    </ul>
                                </div>
                                <div className='tab-content pt-6'>
                                    <div className={clsx('tab-pane', { active: tab === 'Basic' })}>
                                        <div className='row'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Client Nick')}  */}
                                                    {getValueFromResource('Client Nick',dispatch, t)}
                                                    </label>
                                                <input type="text" className="form-control fs-7 fw-normal" id='ClientCode' value={values.ClientCode} name='ClientCode'
                                                    onChange={handleChange('ClientCode')}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3 ">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Email Address')} */}
                                                    {getValueFromResource('Email Address',dispatch, t)}
                                                    </label>
                                                <input type="text" className="form-control fs-7 fw-normal" id='EMailAddress' value={values.EMailAddress} name='EMailAddress'
                                                    onChange={handleChange('EMailAddress')}
                                                />
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Website')} */}
                                                    {getValueFromResource('Website',dispatch, t)}
                                                    </label>
                                                <input type="text" className="form-control fs-7 fw-normal" id='Website' value={values.Website} name='Website'
                                                    onChange={handleChange('Website')}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label fs-7 fw-normal mb-2  d-flex align-items-center gap-1">
                                                    {/* {t('Default Billing Rate')} */}
                                                    {getValueFromResource('Default Billing Rate', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-client"
                                                        data-tooltip-content={getValueFromResource('The standard Hourly rate used when billing the client for work unless overridden by another billing Rate Type.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                {

                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        id="DefaultBillingRate"
                                                        name="DefaultBillingRate"
                                                        value={values.DefaultBillingRate}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
                                                                setFieldValue("DefaultBillingRate", val);
                                                            }
                                                            //setFieldValue("DefaultBillingRate", val);
                                                        }}
                                                        onBlur={(e) => {
                                                            const formatted = formatNumberCustomoriginal(
                                                                cultureInfoName.toString(),
                                                                e.target.value,
                                                                decimalPlaces
                                                            );

                                                            //setFieldValue("DefaultBillingRate", (formatted === "" ? formatNumberCustomoriginalapiv2(cultureInfoName.toString(), 0, decimalPlaces) : formatted));
                                                            setFieldValue("DefaultBillingRate", formatted);
                                                        }}
                                                    />

                                                }

                                            </div>
                                        </div>

                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Details' })}>
                                        <div className='row'>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Address1')} */}
                                                    {getValueFromResource('Address1',dispatch, t)}
                                                    </label>
                                                <input type="text" className="form-control fs-7 fw-normal" id='Address1' value={values.Address1} name='Address1'
                                                    onChange={handleChange('Address1')}

                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Address2')} */}
                                                    {getValueFromResource('Address2',dispatch, t)}
                                                    </label>
                                                <input type="text" className="form-control fs-7 fw-normal" id='Address2' value={values.Address2} name='Address2'
                                                    onChange={handleChange('Address2')}
                                                />
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Country')} */}
                                                    {getValueFromResource('Country',dispatch, t)}
                                                    </label>
                                                <Select
                                                    value={selectedOptionCountry}
                                                    id="CountryId"
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    name="CountryId"
                                                    onBlur={() => setFieldTouched('CountryId', true)}
                                                    onChange={(e) => handleChangeCountry(e, 'CountryId', values)}
                                                    options={countryArray}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('City')} */}
                                                    {getValueFromResource('City',dispatch, t)}
                                                    </label>
                                                <input type="text" className="form-control fs-7 fw-normal" id='City' value={values.City} name='City'
                                                    onChange={handleChange('City')}
                                                />
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('State')} */}
                                                    {getValueFromResource('State',dispatch, t)}
                                                    </label>
                                                <input type="text" className="form-control fs-7 fw-normal" id='State' value={values.State} name='State'
                                                    onChange={handleChange('State')}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Zip Code')} */}
                                                    {getValueFromResource('Zip Code',dispatch, t)}
                                                    </label>
                                                <input type="text" className="form-control fs-7 fw-normal" id='ZipCode' value={values.ZipCode} name='ZipCode'
                                                    onChange={handleChange('ZipCode')}
                                                />
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Telephone1')} */}
                                                    {/* {getValueFromResource('Telephone1',dispatch, t)} */}
                                                    {getValueFromResource('Phone1',dispatch, t)}
                                                    </label>
                                                <input type="text" className="form-control fs-7 fw-normal" id='Telephone1' value={values.Telephone1} name='Telephone1'
                                                    onChange={handleChange('Telephone1')}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Telephone2')} */}
                                                    {/* {getValueFromResource('Telephone2',dispatch, t)} */}
                                                    {getValueFromResource('Phone2',dispatch, t)}
                                                    </label>
                                                <input type="text" className="form-control fs-7 fw-normal" id='Telephone2' value={values.Telephone2} name='Telephone2'
                                                    onChange={handleChange('Telephone2')}
                                                />
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Fax')} */}
                                                    {getValueFromResource('Fax',dispatch, t)}
                                                    </label>
                                                <input type="text" className="form-control fs-7 fw-normal" id='Fax' value={values.Fax} name='Fax'
                                                    onChange={handleChange('Fax')}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                {Object.keys(selectedRecord).length > 0 ? (
                                                    <div className="col-md-12">
                                                        <label className="form-label fs-7 fw-normal mb-2">
                                                            {/* {t('Disabled')} */}
                                                            {getValueFromResource('Disabled',dispatch, t)}
                                                            </label>
                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                            <input className="form-check-input h-20px w-30px" type="checkbox"
                                                                checked={values.IsDisabled} id="IsDisabled"
                                                                onChange={handleChange('IsDisabled')}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Notes' })}  >
                                        <div className='row'>
                                            <div className="col-lg-12 mb-12" >
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Notes')} */}
                                                    {getValueFromResource('Notes',dispatch, t)}
                                                    </label>
                                                <textarea
                                                    rows={4}
                                                    cols={50}
                                                    placeholder=
                                                    // "Enter your text here..."
                                                    {getValueFromResource('Enter your text here...',dispatch, t)}
                                                    id='Notes' value={values.Notes}
                                                    className="form-control fs-7 fw-normal"
                                                    onChange={handleChange('Notes')}

                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Billing' })} >
                                        <div className='row'>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Fixed Bid Billing Mode')} */}
                                                    {getValueFromResource('Fixed Bid Billing Mode', dispatch, t)}
                                                       <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-client"
                                                            data-tooltip-content={getValueFromResource('The billing rate used for fixed-price engagements where work is billed based on an agreed contract value rather than time worked.', dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                </label>
                                                <Select
                                                    value={selectedOptionFixedBidBillingMode}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    name="FixedBidBillingMode"
                                                    onChange={(e) => handleChangeDropdown(e, 'FixedBidBillingMode', values)}
                                                    options={fixedBidBillingModeArray}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                            {showDiv &&
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Fixed Bid Cost')} */}
                                                        {getValueFromResource('Fixed Bid Cost', dispatch, t)}
                                                    </label>
                                                    <input type="text" className="form-control fs-7 fw-normal" id='FixedCost' value={values.FixedCost} name='FixedCost'
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
                                                                setFieldValue("FixedCost", val);
                                                            }

                                                        }}
                                                        onBlur={(e) => {
                                                            const formatted = formatNumberCustomoriginal(
                                                                cultureInfoName.toString(),
                                                                e.target.value,
                                                                decimalPlaces
                                                            );
                                                            setFieldValue("FixedCost", formatted);  // update only on blur
                                                        }} />

                                                </div>
                                            }
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Invoice Template')} */}
                                                    {getValueFromResource('Invoice Template', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-client"
                                                        data-tooltip-content={getValueFromResource('Select a different address of the company already created in the Settings > Invoice Template for Client Invoice.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>

                                                <Select
                                                    value={selectedOptionInvoiceTemplate}
                                                    id="AccountInvoiceTemplateId"
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    name="AccountInvoiceTemplateId"
                                                    onBlur={() => setFieldTouched('AccountInvoiceTemplateId', true)}
                                                    onChange={(e) => handleChangeInvoiceTemplate(e, 'AccountInvoiceTemplateId', values)}
                                                    options={invoicetemplateArray}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>

                                        </div>
                                    </div>
                                    {customFieldsArray && customFieldsArray.length > 0 &&
                                        <div className={clsx('tab-pane', { active: tab === 'CustomField' })}>
                                            <div className='row'>
                                                {customFieldsArray.filter((x: any) => !x.IsDisabled && x.DatabaseFieldName !== '').map((x: any, index: any) =>
                                                    <Fragment key={index}>
                                                        {x.MasterCustomDataTypeName == "Drop-Down" && (
                                                            <>
                                                                <div key={index} className={"col-md-6 mb-3 "}>
                                                                    <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                    {/* <Select
                                                                        name={x.DatabaseFieldName}
                                                                        className="basic-single fs-7 fw-normal"
                                                                        onChange={(e: any) => setFieldValue(x.DatabaseFieldName, e?.value)}
                                                                        styles={dropDownSelectionStyles}
                                                                        value={values[x.DatabaseFieldName] ? { value: values[x.DatabaseFieldName], label: values[x.DatabaseFieldName] } : { value: 'None', label: 'None' }}
                                                                        options={x.DropDownOptions ? x.DropDownOptions.split("+").map((value: any, index: any) => ({ value, label: value })) : []}
                                                                        required={x.IsRequired ? x.IsRequired : ""}
                                                                        maxMenuHeight={maxMenuHeight}
                                                                    /> */}
                                                                    <Select
                                                                        name={x.DatabaseFieldName}
                                                                        className="basic-single fs-7 fw-normal"
                                                                        onChange={(e: any) => setFieldValue(x.DatabaseFieldName, e?.value)}
                                                                        styles={dropDownSelectionStyles}
                                                                        value={values[x.DatabaseFieldName]
                                                                            ? { value: values[x.DatabaseFieldName], label: values[x.DatabaseFieldName] }
                                                                            : { value: 'None', label: 'None' }}
                                                                        options={[
                                                                            { value: 'None', label: 'None' },  // Add "None" option at the start
                                                                            ...x.DropDownOptions
                                                                                ? x.DropDownOptions.split("+").map((value: any) => ({ value, label: value }))
                                                                                : []
                                                                        ]}
                                                                        required={x.IsRequired ? x.IsRequired : ""}
                                                                        maxMenuHeight={maxMenuHeight}
                                                                    />
                                                                    {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Drop-Down')) && (
                                                                        <div style={{ paddingRight: 20 }}>
                                                                            {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                                <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </div>

                                                            </>
                                                        )}
                                                        {x.MasterCustomDataTypeName == "Date" && (
                                                            <>
                                                                <div key={index} className={"col-md-6 mb-3"}>
                                                                    <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                    <div className="wrapper">
                                                                        <DatePicker
                                                                            name={x.DatabaseFieldName}
                                                                            onChange={(date) => setFieldValue(`${x.DatabaseFieldName}`, date ? moment(date).format(customFieldInsertionFormat) : moment(new Date()).format(customFieldInsertionFormat))}
                                                                            //selected={(values[x.DatabaseFieldName] ? moment(values[x.DatabaseFieldName], CurrentCultureDateFormat.toUpperCase()).toDate() : moment().toDate())}
                                                                            selected={(values[x.DatabaseFieldName] ? dateFormatByAccountCulture(values[x.DatabaseFieldName], cultureInfoName.toString()) : new Date())}
                                                                            dateFormat={CurrentCultureDateFormat.toString()}
                                                                            calendarStartDay={calendarStartDay}
                                                                            className="form-control form-con fs-7 fw-normal col-md-1"
                                                                            onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                                        />
                                                                        <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                                    </div>
                                                                    {/* <DatePicker
                                                                    name={x.DatabaseFieldName}
                                                                    // onChange={(date) => setFieldValue(`${x.DatabaseFieldName}`, moment(date).format(CurrentCultureDateFormat.toUpperCase()))}
                                                                    // selected={(values[x.DatabaseFieldName] ? moment(values[x.DatabaseFieldName], CurrentCultureDateFormat.toUpperCase()).toDate() : null)}
                                                                    onChange={(date) => setFieldValue(`${x.DatabaseFieldName}`, date ? moment(date).format(CurrentCultureDateFormat.toUpperCase()) : moment().format(CurrentCultureDateFormat.toUpperCase()))}
                                                                    selected={(values[x.DatabaseFieldName] ? moment(values[x.DatabaseFieldName], CurrentCultureDateFormat.toUpperCase()).toDate() : moment().toDate())}
                                                                    className="form-control form-con fs-7 fw-normal col-md-1"
                                                                    onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                                    /> */}
                                                                    {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Date')) && (
                                                                        <div style={{ paddingRight: 20 }}>
                                                                            {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                                <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </>
                                                        )}

                                                        {(x.MasterCustomDataTypeName == "Text") && (
                                                            <div key={index} className={"col-md-6 mb-3"}>
                                                                <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                <input
                                                                    name={x.DatabaseFieldName}
                                                                    id={x.DatabaseFieldName}
                                                                    //value={values[x.DatabaseFieldName]}
                                                                    value={values[x.DatabaseFieldName] ? values[x.DatabaseFieldName] : ''}
                                                                    //value={(values[x.DatabaseFieldName] !== null && values[x.DatabaseFieldName] !== undefined && values[x.DatabaseFieldName] !== '') ? values[x.DatabaseFieldName] : ''}
                                                                    onChange={handleChange(`${x.DatabaseFieldName}`)}
                                                                    className={"form-control form-con input-sm custom-field custom-field"}
                                                                    //maxLength={x.MaximumLength ? x.MaximumLength : ""}
                                                                    required={x.IsRequired ? x.IsRequired : ""}
                                                                    type="text"
                                                                    // onBlur={() => setFieldTouched(`${x.DatabaseFieldName}`)}
                                                                    onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                                />
                                                                {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Text')) && (
                                                                    <div style={{ paddingRight: 20 }}>
                                                                        {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                            <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                        }
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}

                                                        {(x.MasterCustomDataTypeName == "Number") && (
                                                            <div key={index} className={"col-md-6 mb-3"}>
                                                                <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                <input
                                                                    name={x.DatabaseFieldName}
                                                                    id={x.DatabaseFieldName}
                                                                    value={values[x.DatabaseFieldName] ? values[x.DatabaseFieldName] : ''}
                                                                    //value={values[x.DatabaseFieldName] !== null && values[x.DatabaseFieldName] !== undefined && values[x.DatabaseFieldName] !== '' ? values[x.DatabaseFieldName] : 0}
                                                                    //onChange={handleChange(`${x.DatabaseFieldName}`)}
                                                                    className={"form-control form-con input-sm custom-field custom-field"}
                                                                    //maxLength={x.MaximumLength ? x.MaximumLength : ""}
                                                                    //max={x.MaximumValue !== undefined ? parseFloat(x.MaximumValue) : undefined}
                                                                    //min={x.MinimumValue !== undefined ? parseFloat(x.MinimumValue) : undefined}
                                                                    required={x.IsRequired ? x.IsRequired : ""}
                                                                    type="text"
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            if (validateCultureNumber(value, cultureInfoName.toString(), decimalPlaces)) {
                                                                                setFieldValue(x.DatabaseFieldName, value);
                                                                            }
                                                                        }}
                                                                        onBlur={(e) => {
                                                                            const formatted = formatNumberCustomoriginal(
                                                                                cultureInfoName.toString(),
                                                                                e.target.value,
                                                                                decimalPlaces
                                                                            );
                                                                                    setFieldValue(x.DatabaseFieldName, formatted);

                                                                        }}
                                                                    // onBlur={() => setFieldTouched(`${x.DatabaseFieldName}`)}
                                                                    //onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                                />
                                                                {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Number')) && (
                                                                    <div style={{ paddingRight: 20 }}>
                                                                        {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                            <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                        }
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </Fragment>
                                                )}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </>
                            }
                            {/* Display form-level error summary */}
                       {showErrorSummary && Object.keys(errors).length > 0 && (
                                <div className="mt-3 alert alert-danger">
                                    <strong>
                                        {/* {t('Error Summary')}: */}
                                        {getValueFromResource('Error Summary',dispatch, t)}:
                                        </strong>
                                    <ul>
                                        {Object.keys(errors).map((fieldName, index) => (
                                            <li key={index}>{errors[fieldName] as string}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>

                        <div className='card-footer pt-4 '>
                            <div className='d-flex flex-stack float-end'>
                                <div className='d-flex align-items-center me-2'>
                                    <button
                                        ref={closeButtonRef}
                                        type="button"
                                        className="btn btn-secondary btn-bs-btn-font-weight  me-2 btn-sm fs-7"
                                        id="kt_OffCanvas"
                                        onClick={handleCloseOnClickEvent}
                                    >
                                        {/* {t('Cancel')} */}
                                        {getValueFromResource('Cancel',dispatch, t)}
                                    </button>

                                    <button type="button" data-kt-element='send' className="btn btn-primary btn-bs-btn-font-weight me-2 btn-sm fs-7" 
                                    onClick={() => { setShowErrorSummary(true); 
                                        handleSubmit();
                                    }}
                                    >
                                        {/* {t('Save')} */}
                                        {getValueFromResource('Save',dispatch, t)}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </Fragment>
                )}
            </Formik>
            <ReactTooltip
                id="tooltip-client"
                style={TOOLTIP_STYLE}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? 380 : 220 }}>
                            {content}
                        </div>
                    );
                }}
            />
        </>
    )

}

export default AccountClientForm